import { ColorsEnum } from "../../core/et3-theme/colors";

const ALPHA_SURFACE = "14";
const ALPHA_BORDER = "33";
const ALPHA_BORDER_FOCUS = "80";

export const SIDE_BAR_WIDTH = 300;
export const SIDE_BAR_CONTENT_WIDTH = 250;

export const SIDE_BAR_SEARCH_HEIGHT = 44;
export const SIDE_BAR_SEARCH_RADIUS = 12;
export const SIDE_BAR_SEARCH_PADDING_X = 14;
export const SIDE_BAR_SEARCH_GAP = 10;
export const SIDE_BAR_SEARCH_ICON_SIZE = 16;
export const SIDE_BAR_SEARCH_FONT_SIZE = 16;
export const SIDE_BAR_SEARCH_FIELD_WIDTH = 170;

export const SIDE_BAR_SEARCH_BACKGROUND = `${ColorsEnum.borderBlue}${ALPHA_SURFACE}`;
export const SIDE_BAR_SEARCH_BORDER = `1px solid ${ColorsEnum.borderBlue}${ALPHA_BORDER}`;
export const SIDE_BAR_SEARCH_BORDER_FOCUS = `1px solid ${ColorsEnum.borderBlue}${ALPHA_BORDER_FOCUS}`;

export const SIDE_BAR_PROFILE_RADIUS = 14;
export const SIDE_BAR_PROFILE_HOVER_BACKGROUND = `${ColorsEnum.borderBlue}${ALPHA_SURFACE}`;
export const SIDE_BAR_TRANSITION =
  "background-color 160ms cubic-bezier(0.4, 0, 0.2, 1), border-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";

export const SIDE_BAR_GROUP_HEIGHT = 46;
export const SIDE_BAR_GROUP_RADIUS = 10;
export const SIDE_BAR_GROUP_PADDING_X = 14;
export const SIDE_BAR_GROUP_GAP = 11;
export const SIDE_BAR_GROUP_FONT_SIZE = 15;
export const SIDE_BAR_GROUP_ICON_SIZE = 16;
export const SIDE_BAR_CHEVRON_SIZE = 11;
export const SIDE_BAR_ROW_WIDTH = 284;
export const SIDE_BAR_ACCENT_WIDTH = 3;
export const SIDE_BAR_ACCENT_RADIUS = 2;

export const SIDE_BAR_SUB_HEIGHT = 38;
export const SIDE_BAR_SUB_FONT_SIZE = 14;
export const SIDE_BAR_SUB_INDENT = 4;
export const SIDE_BAR_MENU_PADDING_X = 8;
export const SIDE_BAR_SUB_RADIUS = 8;
export const SIDE_BAR_SUB_GAP = 8;
export const SIDE_BAR_RAIL_INSET = 18;
export const SIDE_BAR_RAIL_BORDER = `1px solid ${ColorsEnum.borderBlue}24`;
export const SIDE_BAR_SUB_PADDING_RIGHT = 8;
export const SIDE_BAR_SUB_MENU_WIDTH = SIDE_BAR_ROW_WIDTH - SIDE_BAR_RAIL_INSET;

export const SIDE_BAR_SALARY_FONT_SIZE = 26;
export const SIDE_BAR_SALARY_LABEL_FONT_SIZE = 13;
export const SIDE_BAR_SALARY_LABEL_OPACITY = 0.6;

export const SIDE_BAR_LABEL_MUTED = ColorsEnum.borderBlue;
export const SIDE_BAR_ROW_HOVER_BACKGROUND = `${ColorsEnum.borderBlue}12`;
export const SIDE_BAR_ROW_ACTIVE_BACKGROUND = `${ColorsEnum.bondiBlue}29`;
export const SIDE_BAR_SALARY_LETTER_SPACING = 0.8;
export const SIDE_BAR_SALARY_BLOCK_HEIGHT = 56;

export const SIDE_BAR_TAG_HEIGHT = 18;
export const SIDE_BAR_TAG_PADDING = 6;
export const SIDE_BAR_TAG_FONT_SIZE = 9;
export const SIDE_BAR_TAG_RADIUS = 4;
export const SIDE_BAR_TAG_LETTER_SPACING = 0.4;
export const SIDE_BAR_TAG_COLOR = ColorsEnum.darkOrange;
export const SIDE_BAR_TAG_BACKGROUND = `${ColorsEnum.darkOrange}29`;
